import styled from '@emotion/styled';
import { colors, Modal, Stack } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  width: 515,
});

export const PeriodCallout = styled(Stack)({
  backgroundColor: colors.gray[100],
  borderRadius: 8,
});
